import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBatchPayment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8367 13.8366C12.8511 13.8366 13.6735 13.0142 13.6735 11.9998C13.6735 10.9854 12.8511 10.1631 11.8367 10.1631C10.8223 10.1631 10 10.9854 10 11.9998C10 13.0142 10.8223 13.8366 11.8367 13.8366Z",
			stroke: "#FFB3B3",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.0968 6.5H4.90308C3.55055 6.5 2.4541 7.59645 2.4541 8.94898V15.051C2.4541 16.4036 3.55055 17.5 4.90308 17.5H19.0968C20.4493 17.5 21.5458 16.4036 21.5458 15.051V8.94898C21.5458 7.59645 20.4493 6.5 19.0968 6.5Z",
			stroke: "#FFB3B3",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.2102 10.1735C20.4454 10.0439 19.7398 9.67961 19.1913 9.13111C18.6429 8.58261 18.2785 7.87709 18.1489 7.1123",
			stroke: "#FFB3B3",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.1489 16.7956C18.2785 16.0308 18.6429 15.3253 19.1913 14.7768C19.7398 14.2283 20.4454 13.864 21.2102 13.7344",
			stroke: "#FFB3B3",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.87744 13.7344C3.64222 13.864 4.34775 14.2283 4.89625 14.7768C5.44474 15.3253 5.80904 16.0308 5.93867 16.7956",
			stroke: "#FFB3B3",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.93867 7.1123C5.80904 7.87709 5.44474 8.58261 4.89625 9.13111C4.34775 9.67961 3.64222 10.0439 2.87744 10.1735",
			stroke: "#FFB3B3",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgBatchPayment;
